<script setup lang="ts">
  import { endOfDay, startOfDay } from 'date-fns'
  import { ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const date1 = ref<Date>()
  const date2 = ref<Date>()

  const submitDate = () => {
    updateRoute({
      date_start: date1.value && date2.value ? date1.value.toISOString() : undefined,
      date_end: date1.value && date2.value ? date2.value.toISOString() : undefined,
    })
  }

  if (route.query.date_start) {
    date1.value = startOfDay(new Date(route.query.date_start as string))
  } else {
    date1.value = startOfDay(new Date())
  }
  if (route.query.date_end) {
    date2.value = endOfDay(new Date(route.query.date_end as string))
  } else {
    date2.value = endOfDay(new Date())
  }
  if (! route.query.date_start && ! route.query.date_end) {
    submitDate()
  }

  watch([date1, date2], submitDate)
</script>

<template>
  <app-date-range-picker
    v-model:date1="date1!"
    v-model:date2="date2!" />
</template>
